export const convertMetricVolume = (num: number) => num / 16.018;

export const round = (num: number) => Math.round((num + Number.EPSILON) * 100) / 100;
